import React, { useState, useEffect, useRef } from "react";
import "./ConsentForm.css"; // optional — move <style> content here
import { Box, Modal, Grid } from "@mui/material";
import { useAppContext } from "../context/AppContext";
import moment from "moment";
import SignatureCanvas from "react-signature-canvas";
import { saveConsentForm } from "../helpers/UserChats";
import { CircularProgress } from "@mui/material";
import Toast from "./toast";

const ConsentForm = ({
  open,
  handleClose,
  handleSignConsentForm,
  initialData,
}) => {
  const sigRef = useRef(null);
  // const canvasRef = useRef(null);
  const { isMobile } = useAppContext();

  // const [isDrawing, setIsDrawing] = useState(false);
  // const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
  const [formData, setFormData] = useState({
    patientName: "",
    dob: "",
    email: "",
    phone: "",
    legalRep: "",
    relationship: "",
    facility: "",
    typedSig: "",
    signedByRole: "",
    consentDate: "",
    consentTime: "",
    sigImage: "",
    timezone: "",
    userAgent: "",
    timestampISO: "",
    ipAddress: "",
  });
  const [acknowledgements, setAcknowledgements] = useState({
    ack1: false,
    ack2: false,
    ack3: false,
    ack4: false,
    ack5: false,
    ack6: false,
    ack7: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  // const [showSuccess, setShowSuccess] = useState(false);

  // Auto-fill date, time, timezone, user agent
  useEffect(() => {
    console.log(initialData)
    const now = new Date();
    const pad = (n) => (n < 10 ? "0" + n : n);
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offset = -now.getTimezoneOffset();
    const sign = offset >= 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const hh = pad(Math.floor(absOffset / 60));
    const mm = pad(absOffset % 60);
    const iso = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate(),
    )}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
      now.getSeconds(),
    )}${sign}${hh}:${mm}`;
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

    setFormData((prev) => ({
      ...prev,
      consentDate: prev.consentDate || now.toISOString().slice(0, 10),
      consentTime: time,
      timezone: tz,
      userAgent: navigator.userAgent,
      timestampISO: iso,
    }));

    if (initialData !== null) {
      setFormData((prev) => ({
        ...prev,
        patientName: initialData["3"],
        dob: moment(initialData["4"]).format("YYYY-MM-DD"),
        email: initialData["5"],
        phone: initialData["6"],
        relationship: initialData["200"],
      }));
    }

    // Canvas dimensions
    const canvas = sigRef.current?.getCanvas();
    if (!canvas) return;

    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;

    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
  }, [open]);

  // Check if submit should be enabled
  const isSubmitEnabled =
    Object.values(acknowledgements).every(Boolean) &&
    formData.typedSig.trim().length >= 2 &&
    formData.signedByRole !== "";

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle checkbox change
  const handleAckChange = (e) => {
    const { id, checked } = e.target;
    setAcknowledgements((prev) => ({ ...prev, [id]: checked }));
  };

  // useEffect(() => {
  //   const canvas = canvasRef.current;
  //   if (!canvas) return;

  //   const rect = canvas.getBoundingClientRect();
  //   canvas.width = rect.width;
  //   canvas.height = rect.height;
  // }, [Modal]);

  // Signature Pad Logic
  // useEffect(() => {
  //   if (typeof window === "undefined") return;

  //   const canvas = canvasRef.current;
  //   if (!canvas) return;

  //   const ctx = canvas.getContext("2d");
  //   ctx.lineWidth = 2;
  //   ctx.lineCap = "round";
  //   ctx.strokeStyle = "#000";

  //   const getPos = (e) => {
  //     const rect = canvas.getBoundingClientRect();
  //     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  //     const clientY = e.touches ? e.touches[0].clientY : e.clientY;
  //     return {
  //       x: clientX - rect.left,
  //       y: clientY - rect.top,
  //     };
  //   };

  //   const startDrawing = (e) => {
  //     setIsDrawing(true);
  //     const pos = getPos(e);
  //     setLastPos(pos);
  //     e.preventDefault();
  //   };

  //   const draw = (e) => {
  //     if (!isDrawing) return;
  //     const pos = getPos(e);
  //     ctx.beginPath();
  //     ctx.moveTo(lastPos.x, lastPos.y);
  //     ctx.lineTo(pos.x, pos.y);
  //     ctx.stroke();
  //     setLastPos(pos);
  //     e.preventDefault();
  //   };

  //   const stopDrawing = () => {
  //     if (isDrawing) {
  //       setIsDrawing(false);
  //       setFormData((prev) => ({
  //         ...prev,
  //         sigImage: canvas.toDataURL("image/png"),
  //       }));
  //     }
  //   };

  //   // Mouse events
  //   canvas.addEventListener("mousedown", startDrawing);
  //   canvas.addEventListener("mousemove", draw);
  //   window.addEventListener("mouseup", stopDrawing);

  //   // Touch events
  //   canvas.addEventListener("touchstart", startDrawing, { passive: false });
  //   canvas.addEventListener("touchmove", draw, { passive: false });
  //   canvas.addEventListener("touchend", stopDrawing);

  //   return () => {
  //     canvas.removeEventListener("mousedown", startDrawing);
  //     canvas.removeEventListener("mousemove", draw);
  //     window.removeEventListener("mouseup", stopDrawing);
  //     canvas.removeEventListener("touchstart", startDrawing);
  //     canvas.removeEventListener("touchmove", draw);
  //     canvas.removeEventListener("touchend", stopDrawing);
  //   };
  // }, [isDrawing, lastPos]);

  const handlePrint = () => {
    // 1. Create a hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    // 2. Wait for iframe to load
    iframe.onload = () => {
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      // 3. Copy ONLY the <main> content (your form)
      const mainContent = document.querySelector("main")?.cloneNode(true);
      if (!mainContent) return;

      // 4. Build minimal HTML with your original styles
      const styleSheets = Array.from(document.styleSheets)
        .map((sheet) => {
          try {
            if (sheet.href) {
              return `<link rel="stylesheet" href="${sheet.href}" />`;
            }
            const rules = Array.from(sheet.cssRules)
              .map((r) => r.cssText)
              .join("\n");
            return `<style>${rules}</style>`;
          } catch (e) {
            return "";
          }
        })
        .join("");

      const printHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <title>Telemedicine Consent</title>
        ${styleSheets}
        <style>
          @media print {
            body { margin: 0; padding: 1rem; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
            .actions, .footer, button, .btn { display: none !important; }
          }
          body { background: #fff; }
        </style>
      </head>
      <body>${mainContent.outerHTML}</body>
      </html>
    `;

      doc.open();
      doc.write(printHTML);
      doc.close();

      // 5. Trigger print
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // 6. Clean up after print dialog closes
        const removeIframe = () => {
          document.body.removeChild(iframe);
          iframe.contentWindow.removeEventListener("afterprint", removeIframe);
        };
        iframe.contentWindow.addEventListener("afterprint", removeIframe);
      }, 250);
    };

    // Trigger iframe load
    iframe.src = "about:blank";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Capture signature if not already saved
    if (!formData.sigImage && sigRef.current) {
      setFormData((prev) => ({
        ...prev,
        sigImage: sigRef.current.toDataURL("image/png"),
      }));
    }
    const values = {
      ...formData,
      sigImage: sigRef.current.toDataURL("image/png"),
      acknowledgements,
      chatId: initialData?.chatId || null,
    };

    // Simulate submission
    console.log("Form submitted:", values);
    try {
      setIsLoading(true);
      const response = await saveConsentForm(values);
      setIsLoading(false);
      if (response.statusCode === 200 && response.isSuccess === true) {
        Toast.success(response.message);
        handleSignConsentForm();
      } else {
        Toast.error(response.message);
      }
    } catch (error) {
      Toast.error(error.message);
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      patientName: "",
      dob: "",
      email: "",
      phone: "",
      legalRep: "",
      relationship: "",
      facility: "",
      typedSig: "",
      signedByRole: "",
      consentDate: "",
      consentTime: "",
      sigImage: "",
      timezone: "",
      userAgent: "",
      timestampISO: "",
      ipAddress: "",
    });
    setAcknowledgements({
      ack1: false,
      ack2: false,
      ack3: false,
      ack4: false,
      ack5: false,
      ack6: false,
      ack7: false,
    });
    sigRef.current.clear();
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : "80%",
    bgcolor: "#f0f0f0",
    border: "2px solid #000",
    borderRadius: "12px",
    boxShadow: 24,
    p: 0,
    maxHeight: "80vh", // set max height
    overflow: "auto", // enable scrolling
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <header>
          <div className="wrap">
            <img
              alt="Logo"
              src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='56' height='56'><rect width='56' height='56' rx='8' fill='%23ffffff'/><text x='50%' y='54%' text-anchor='middle' font-family='Arial' font-size='20' fill='%230f62fe'>HL</text></svg>"
            />
            <div>
              <h1>
                Telemedicine Consent for Pre‑Move Evaluation (PME){" "}
                <span className="pill">Click‑to‑Consent</span>
              </h1>
              <div className="small">
                For assisted living placement evaluations conducted online via
                secure telehealth.
              </div>
            </div>
          </div>
        </header>

        <main>
          <form id="consentForm" onSubmit={handleSubmit} noValidate>
            <section>
              <div className="disclaimer">
                <strong>Important:</strong> This telemedicine consent confirms
                you understand the nature, risks, benefits, and limits of an
                online PME. This evaluation supports assisted living placement
                decisions but <em>does not</em> replace emergency care or
                ongoing treatment from your physicians. If you are experiencing
                an emergency, call 911 immediately.
              </div>
            </section>

            <section>
              <h2>Patient & Contact Information</h2>
              <Box
                sx={{
                  display: "grid",
                  width: "100%",
                  gridTemplateColumns: {
                    sm: "repeat(1, 1fr)", // 1 column on very small modals
                    md: "repeat(2, 1fr)", // 2 columns otherwise
                  },
                  gap: 1,
                }}
              >
                <Box>
                  <label htmlFor="patientName">
                    Patient Full Name<span className="req">*</span>
                  </label>
                  <input
                    className="textinput"
                    id="patientName"
                    name="patientName"
                    type="text"
                    value={formData.patientName}
                    onChange={handleInputChange}
                    required
                  />
                </Box>
                <Box>
                  <label htmlFor="dob">
                    Date of Birth<span className="req">*</span>
                  </label>
                  <input
                    className="textinput"
                    id="dob"
                    name="dob"
                    type="date"
                    value={formData.dob}
                    onChange={handleInputChange}
                    required
                  />
                </Box>
                <Box>
                  <label htmlFor="email">
                    Email<span className="req">*</span>
                  </label>
                  <input
                    className="textinput"
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Box>
                <Box>
                  <label htmlFor="phone">
                    Phone<span className="req">*</span>
                  </label>
                  <input
                    className="textinput"
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </Box>
                <Box>
                  <label htmlFor="legalRep">
                    Legal Representative (if applicable)
                  </label>
                  <input
                    className="textinput"
                    id="legalRep"
                    name="legalRep"
                    type="text"
                    placeholder="Name of guardian/POA/health proxy"
                    value={formData.legalRep}
                    onChange={handleInputChange}
                  />
                </Box>
                <Box>
                  <label htmlFor="relationship">Relationship</label>
                  <input
                    className="textinput"
                    id="relationship"
                    name="relationship"
                    type="text"
                    placeholder="e.g., Daughter, POA, Guardian"
                    value={formData.relationship}
                    onChange={handleInputChange}
                  />
                </Box>
                <Box>
                  <label htmlFor="facility">
                    Intended Assisted Living Facility
                  </label>
                  <input
                    className="textinput"
                    id="facility"
                    name="facility"
                    type="text"
                    placeholder="Facility name (optional)"
                    value={formData.facility}
                    onChange={handleInputChange}
                  />
                </Box>
              </Box>
            </section>

            <section>
              <h2>Consent Disclosures</h2>
              {[
                {
                  title: "Nature & Purpose of Telemedicine",
                  content: "The PME is performed via secure audio/video...",
                },
                {
                  title: "Risks & Limitations",
                  content:
                    "Telemedicine may be limited by technology issues...",
                },
                {
                  title: "Privacy & Security (HIPAA)",
                  content:
                    "Your information will be safeguarded using HIPAA‑compliant platforms...",
                },
                {
                  title: "Data Sharing Authorization",
                  content: "You authorize us to share the PME summary...",
                },
                {
                  title: "Patient Rights",
                  content:
                    "You may ask questions; decline or withdraw consent...",
                },
                {
                  title: "Emergency & Ongoing Care",
                  content: "Telemedicine PME is not emergency care...",
                },
                {
                  title: "Financial Responsibility",
                  content: "You are responsible for PME fees as posted...",
                },
                {
                  title: "Limitation of Liability",
                  content: "To the fullest extent permitted by law...",
                },
                {
                  title: "E‑Signature Consent (ESIGN)",
                  content:
                    "By typing your name and/or drawing your signature...",
                },
              ].map((item, i) => (
                <details key={i} open={i === 0}>
                  <summary>{item.title}</summary>
                  <div className="muted">{item.content}</div>
                </details>
              ))}
            </section>

            <section>
              <h2>Required Acknowledgements</h2>
              <div className="ack-list">
                {[
                  "I have read and understand the Telemedicine Nature & Purpose disclosure.",
                  "I understand the Risks & Limitations and that an in‑person evaluation may be required.",
                  "I acknowledge the HIPAA Privacy & Security statement and authorize necessary data sharing.",
                  "I understand the Emergency & Ongoing Care statement and that this PME is not emergency care.",
                  "I accept the Financial Responsibility terms.",
                  "I accept the Limitation of Liability.",
                  "I consent to Electronic Signatures (ESIGN) for this PME.",
                ].map((text, i) => (
                  <label key={i} className="checkbox">
                    <input
                      type="checkbox"
                      id={`ack${i + 1}`}
                      checked={acknowledgements[`ack${i + 1}`]}
                      onChange={handleAckChange}
                      required
                    />
                    <span>{text}</span>
                    <span className="req">*</span>
                  </label>
                ))}
              </div>
            </section>

            <section>
              <h2>Consent & Signature</h2>
              <Box
                sx={{
                  display: "grid",
                  width: "100%",
                  gridTemplateColumns: {
                    sm: "repeat(1, 1fr)", // 1 column on very small modals
                    md: "repeat(2, 1fr)", // 2 columns otherwise
                  },
                  gap: 1,
                }}
              >
                <Box>
                  <label htmlFor="typedSig">
                    Type Full Name (e‑signature)<span className="req">*</span>
                  </label>
                  <input
                    className="textinput"
                    id="typedSig"
                    name="typedSig"
                    type="text"
                    value={formData.typedSig}
                    onChange={handleInputChange}
                    required
                  />
                </Box>
                <Box>
                  <label htmlFor="signedByRole">
                    Signer Role<span className="req">*</span>
                  </label>
                  <select
                    className="textinput"
                    id="signedByRole"
                    name="signedByRole"
                    value={formData.signedByRole}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select…</option>
                    <option>Patient</option>
                    <option>Parent/Guardian</option>
                    <option>POA/Health Proxy</option>
                    <option>Other Representative</option>
                  </select>
                </Box>
                <Box>
                  <label htmlFor="consentDate">Date</label>
                  <input
                    className="textinput"
                    id="consentDate"
                    name="consentDate"
                    type="date"
                    value={formData.consentDate}
                    onChange={handleInputChange}
                    readOnly
                  />
                </Box>
                <Box>
                  <label htmlFor="consentTime">Time</label>
                  <input
                    className="textinput"
                    id="consentTime"
                    name="consentTime"
                    type="text"
                    placeholder="Auto‑filled"
                    value={formData.consentTime}
                    readOnly
                  />
                </Box>
                <Box>
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      border: "2px dashed #bdbdbd",
                      borderRadius: 1,
                      width: "100%",
                      marginBottom: "5px",
                    }}
                  >
                    <SignatureCanvas
                      ref={sigRef}
                      penColor="black"
                      canvasProps={{
                        style: {
                          width: "100%",
                          height: 160,
                          backgroundColor: "#fff",
                          touchAction: "none",
                        },
                      }}
                    />
                  </Box>
                  <button type="button" onClick={() => sigRef.current.clear()}>
                    Clear
                  </button>
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "grid",
                  width: "100%",
                  gridTemplateColumns: {
                    md: "repeat(1, 1fr)", // 2 columns otherwise
                  },
                  gap: 1,
                }}
              >
                <Box sx={{ backgroundColor: "green" }}>
                  <label>Draw Signature (optional)</label>
                  <canvas ref={canvasRef} className="sig-pad"></canvas>
                  <div>
                    <button
                      type="button"
                      className="secondary"
                      onClick={clearSignature}
                    >
                      Clear
                    </button>
                  </div>
                  <input
                    type="hidden"
                    name="sigImage"
                    value={formData.sigImage}
                  />
                </Box>
              </Box> */}
              {/* <div className="grid">
                <div>
                  <label htmlFor="typedSig">
                    Type Full Name (e‑signature)<span className="req">*</span>
                  </label>
                  <input
                    id="typedSig"
                    name="typedSig"
                    type="text"
                    value={formData.typedSig}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="signedByRole">
                    Signer Role<span className="req">*</span>
                  </label>
                  <select
                    id="signedByRole"
                    name="signedByRole"
                    value={formData.signedByRole}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select…</option>
                    <option>Patient</option>
                    <option>Parent/Guardian</option>
                    <option>POA/Health Proxy</option>
                    <option>Other Representative</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="consentDate">Date</label>
                  <input
                    id="consentDate"
                    name="consentDate"
                    type="date"
                    value={formData.consentDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label htmlFor="consentTime">Time</label>
                  <input
                    id="consentTime"
                    name="consentTime"
                    type="text"
                    placeholder="Auto‑filled"
                    value={formData.consentTime}
                    readOnly
                  />
                </div>
                <div className="full">
                  <label>Draw Signature (optional)</label>
                  <canvas
                    ref={canvasRef}
                    className="sig-pad"
                    width={700}
                    height={160}
                  ></canvas>
                  <div className="actions">
                    <button
                      type="button"
                      className="secondary"
                      onClick={clearSignature}
                    >
                      Clear
                    </button>
                  </div>
                  <input
                    type="hidden"
                    name="sigImage"
                    value={formData.sigImage}
                  />
                </div>
              </div> */}
            </section>

            <section style={{ marginTop: "10px" }}>
              <div className="muted small">
                By signing, you affirm you are authorized to provide consent for
                this patient.
              </div>
              <div className="actions">
                <button
                  type="submit"
                  className={isSubmitEnabled ? "primary" : "secondary"}
                  disabled={!isSubmitEnabled}
                  style={{ cursor: isSubmitEnabled ? "pointer" : "default" }}
                  // onClick={handleSign}
                >
                  {isLoading === true ? (
                    <CircularProgress color="#fff" size={"24px"} />
                  ) : (
                    "I Agree &Sign"
                  )}
                </button>
                {/* <button
                  type="button"
                  className="secondary"
                  onClick={handlePrint}
                >
                  Print / Save as PDF
                </button> */}
                <button type="button" className="danger" onClick={handleReset}>
                  Reset
                </button>
                <button type="button" className="danger" onClick={handleClose}>
                  Cancel
                </button>
              </div>
              {/* {showSuccess && (
                <div className="footer">
                  <div
                    className="success"
                    style={{
                      padding: "10px 12px",
                      borderRadius: "8px",
                      marginTop: "12px",
                    }}
                  >
                    Consent recorded locally. Be sure to configure your form
                    endpoint to store records securely.
                  </div>
                </div>
              )} */}
            </section>

            {/* Hidden Fields */}
            <input type="hidden" name="timezone" value={formData.timezone} />
            <input type="hidden" name="userAgent" value={formData.userAgent} />
            <input
              type="hidden"
              name="timestampISO"
              value={formData.timestampISO}
            />
            <input type="hidden" name="ipAddress" value={formData.ipAddress} />
          </form>

          {/* <div className="footer">
            <strong>Implementation Notes (remove before publishing):</strong>
            <ul>
              <li>
                Set the form action to your secure endpoint (e.g., EMR intake,
                HIPAA‑compliant form handler) and use HTTPS.
              </li>
              <li>
                Store the signature image (base64) and typed signature with
                timestamp, TZ, and user agent; capture IP on the server.
              </li>
              <li>
                Link your Notice of Privacy Practices (NPP) above and add your
                logo in the header.
              </li>
            </ul>
          </div> */}
        </main>
      </Box>
    </Modal>
  );
};

export default ConsentForm;
